// @flow
import { finectAPI } from '@finect/front-utils/finectAPI';

export const ADVISERS_PER_PAGE = 20;

/**
 * Ruta del listado de asesores en la API v4.
 *
 * @param province Slug de provincia. Si no se pasa, el listado es nacional.
 * @param offset   Desplazamiento de la página. Se omite cuando es 0 o null.
 */
export const getAdvisersPath = ({ province, offset }: { province?: ?string, offset?: ?number }): string => {
  const filter = `subtype+eq+'user'${province ? `+and+province+eq+'${province}'` : ''}`;

  return `contents/profiles/advisers?filter=${filter}&limit=${ADVISERS_PER_PAGE}${offset ? `&offset=${offset}` : ''}`;
};

/**
 * Petición del listado de asesores. Cada escena decide qué hace con la respuesta,
 * porque unas reemplazan el listado y otras lo van acumulando.
 *
 * @param province  Slug de provincia (opcional).
 * @param offset    Desplazamiento de la página.
 * @param onSuccess Handler de respuesta correcta.
 * @param onError   Handler de error.
 */
export const fetchAdvisers = ({ province, offset, onSuccess, onError }: Object): Promise<any> =>
  finectAPI({
    version: 'v4',
    path: getAdvisersPath({ province, offset }),
    method: 'GET',
    onSuccess,
    onError
  });
